import React from 'react';


const Socials = () => {
  return (
    <div className='home__social'>
        <a href="https://github.com/MokomCollinsAwah" className="home__social-icon" target='_blank' rel='noreferrer' aria-label="Visit Mokom Collins on GitHub">
            <i className="uil uil-github" aria-hidden="true"></i>
        </a>
        <a href="https://www.linkedin.com/in/mokomcollinsawah" className="home__social-icon" target='_blank' rel='noreferrer' aria-label="Visit Mokom Collins on LinkedIn">
            <i className="uil uil-linkedin" aria-hidden="true"></i>
        </a>
        <a href="https://www.instagram.com/mokomcollinsawah" className="home__social-icon" target='_blank' rel='noreferrer' aria-label="Visit Mokom Collins on Instagram">
            <i className="uil uil-instagram" aria-hidden="true"></i>
        </a>
        <a href="https://www.facebook.com/mokomcollinsawah" className="home__social-icon" target='_blank' rel='noreferrer' aria-label="Visit Mokom Collins on Facebook">
            <i className="uil uil-facebook" aria-hidden="true"></i>
        </a>
        <a href="https://twitter.com/mokomcollins" className="home__social-icon" target='_blank' rel='noreferrer' aria-label="Visit Mokom Collins on Twitter">
            <i className="uil uil-twitter" aria-hidden="true"></i>
        </a>
    </div>
  )
}

export default Socials